import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Тут больше ничего нет ")

import { watch } from "vue";

import { useAsync } from "@/use/useAsync";
import { useNews } from "@/use/useNews";
import { useStore } from "@/use/useStore";

import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import NewsPost from "./NewsPost.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsList',
  setup(__props) {

const { currentUser } = useStore();
const { news, fetchNews } = useNews();

const fetchData = useAsync(() => fetchNews({ limit: "25" }), true);

watch(() => currentUser.value?.id, fetchData.execute);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiSuspense, {
    failure: _unref(fetchData).isFailure.value,
    pending: _unref(fetchData).isPending.value,
    success: _unref(fetchData).isSuccess.value,
    variant: "screen",
    "has-retry": ""
  }, {
    default: _withCtx(() => [
      _createVNode(UiGroup, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news), (post) => {
            return (_openBlock(), _createBlock(UiCard, {
              key: post.id
            }, {
              default: _withCtx(() => [
                _createVNode(NewsPost, { post: post }, null, 8, ["post"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(UiCaption, {
        level: "3",
        style: {"text-align":"center"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["failure", "pending", "success"]))
}
}

})